import { ComponentType } from 'react';
import { AppBarProps, Layout, LayoutProps, MenuProps } from 'react-admin';

import CssBaseline from '@mui/material/CssBaseline';

import { CustomAppBar } from '@app/components/CustomAppBar';
import { CustomMenu } from '@app/components/CustomMenu';

export default function MainLayout(props: LayoutProps) {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Layout
        {...props}
        //prevent unnecessary scroll
        style={{ marginTop: '-8px' }}
        appBar={CustomAppBar as ComponentType<AppBarProps>}
        menu={CustomMenu as ComponentType<MenuProps>}
      />
    </>
  );
}
